import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@solar/shared/material.module';
import { DynamicTabDirective } from './dynamictabdirective.directive';
import { MainTabComponent } from './maintab.component';
import { TabComponent } from './tab.component';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule
    , ReactiveFormsModule
  ]
  , declarations: [
    TabComponent,
    DynamicTabDirective,
    MainTabComponent
  ],
  providers: [],
  // register the dynamic components here
  entryComponents: []
  ,exports: [

    TabComponent
    ,DynamicTabDirective
    ,MainTabComponent    
  ]
})
export class FrTabModule { }